<template>
  <div class="month-filter-dropdown-period">
    <tr-slimbox
      :with-shadow="true"
      arrow-direction="top-center"
    >
      <tr-form
        :name="formName"
        :on-valid-submit="filter"
      >
        <div class="row">
          <tr-text-field
            v-model="initialDate"
            classes="col-lg-5 no-padding-right"
            type="date"
            :hide-calendar-icon="true"
            datepicker-orientation="bottom"
            :custom-validation="validateRange"
            :error-message="initialDateError"
            required="true"
            name="initialDate"
          />
          <tr-typography classes="col-lg-2 vertical-offset1 text-center">
            à
          </tr-typography>
          <tr-text-field
            v-model="endDate"
            classes="col-lg-5 no-padding-left"
            type="date"
            :hide-calendar-icon="true"
            datepicker-orientation="bottom"
            error-message="Data final inválida"
            required="true"
            name="endDate"
          />
        </div>
        <div class="row vertical-offset1">
          <tr-button
            classes="col-lg-5 no-padding-right"
            label="cancelar"
            :on-button-click="close"
            block-size="true"
            variant="outlined"
            size="small"
            color="secondary"
          />
          <div class="col-lg-2" />
          <tr-button
            classes="col-lg-5 no-padding-left"
            label="OK"
            block-size="true"
            type="submit"
            variant="raised"
            size="small"
            color="primary"
          />
        </div>
      </tr-form>
    </tr-slimbox>
  </div>
</template>

<script>
import TrForm from './TrForm.vue';
import TrTextField from './TrTextField.vue';
import TrTypography from './TrTypography.vue';
import TrButton from './TrButton.vue';
import TrSlimbox from './TrSlimbox.vue';
import jQuery from 'jquery';
import moment from '@transfeeradev/moment';

const DATE_FORMAT = 'DD/MM/YYYY';

const component = {
  name: 'tr-period-selection',
  props: {
    onFilterPeriod: {
      required: true,
      type: Function
    },
    formName: {
      required: false,
      type: String,
      default: 'period-selection-form'
    },
    onShow: {
      required: false,
      type: Function
    },
    onHide: {
      required: false,
      type: Function
    },
    range: {
      required: false,
      type: Object
    }
  },
  data: () => ({
    initialDate: null,
    initialDateError: '',
    endDate: null
  }),
  components: {
    TrForm,
    TrTextField,
    TrTypography,
    TrButton,
    TrSlimbox
  },
  methods: {
    filter() {
      this.close();
      this.onFilterPeriod(moment(this.initialDate, DATE_FORMAT),
        moment(this.endDate, DATE_FORMAT));
    },
    open() {
      const dropdownOpener = _getDropdownOpener(this.$el);

      this.show();

      dropdownOpener.addEventListener('mouseenter', this.show);
      dropdownOpener.addEventListener('mouseleave', this.hide);
    },
    validateRange(startDate) {
      if (this.endDate) {
        if (moment(startDate, DATE_FORMAT).isAfter(moment(this.endDate, DATE_FORMAT))) {
          this.initialDateError = 'Data inicial deve ser válida e menor que a data final';
          return false;
        }

        if (this.range) {
          if (this.range.max && this.range.max.value) {
            const rangeDiff = moment(this.endDate, DATE_FORMAT).diff(moment(startDate, DATE_FORMAT), this.range.max.unit || 'days');
            if (rangeDiff > this.range.max.value) {
              this.initialDateError = this.range.max.error;
              return false;
            }
          }

          if (this.range.min && this.range.min.value) {
            const rangeDiff = moment(this.endDate, DATE_FORMAT).diff(moment(startDate, DATE_FORMAT), this.range.min.unit || 'days');
            if (rangeDiff < this.range.min.value) {
              this.initialDateError = this.range.min.error;
              return false;
            }
          }
        }
      }

      return true;
    },
    close() {
      const dropdownOpener = _getDropdownOpener(this.$el);

      this.hide(null, true);

      dropdownOpener.removeEventListener('mouseenter', this.show);
      dropdownOpener.removeEventListener('mouseleave', this.hide);
    },
    show() {
      this.$el.style.display = 'block';
      if (this.onShow) {
        this.onShow();
      }
      _centerPeriodSelection(this.$el);
    },
    hide(event, force) {
      if (force || !document.querySelector('.datepicker')) {
        this.$el.style.display = 'none';
        const input = jQuery(this.$el.querySelectorAll('input'));
        input.datepicker('hide');
        if (this.onHide) {
          this.onHide();
        }
      }
    }
  }
};

const _centerPeriodSelection = periodSelection => {
  const periodSelectionWidthSetByCss = periodSelection.offsetWidth;

  _clearPeriodSelectionCssStyle(periodSelection);

  const initialPeriodSelectionWidth = periodSelection.offsetWidth;

  _restorePeriodSelectionWidth(periodSelection, periodSelectionWidthSetByCss);

  periodSelection.style.left = ((periodSelectionWidthSetByCss - initialPeriodSelectionWidth) / 2) * -1 + 'px';
};

const _clearPeriodSelectionCssStyle = periodSelection => {
  periodSelection.style.width = 'initial';
  periodSelection.style.left = 0;
};

const _restorePeriodSelectionWidth = (periodSelection, periodSelectionWidthSetByCss) => {
  periodSelection.style.width = periodSelectionWidthSetByCss + 'px';
};

const _getDropdownOpener = element => (
  element.closest('.dropdown')
);

export default component;
</script>
